import { useState, useEffect, useRef, useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
  Avatar,
  Button,
  Box,
  CircularProgress,
  Dialog,
  IconButton,
  Typography,
  TextField,
  Chip,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CopyToClipboardButton from '../../component/CopyClipBoardButton';
import SocialMediaLinks from './socialMediaLinks';
import ChatButtonIcon from '../../svg/ChatButtonIcon';
import Textboxstar from '../../svg/textboxstar';
import JournalIcon from '../../svg/JournalIcon';
import { useAuth } from '../../hooks/useAuth';
import { Timestamp } from 'firebase/firestore';
import { useTheme } from '@mui/material/styles';
import SendChatIcon from '../../svg/SendChatIcon';
import { useNavigate } from 'react-router-dom';
import { drawerWidth, drawerWidthClosed } from '../leftNav';
import { getOnBoradingDetailedProgress, getPrices } from '../../utils/api';
import AttachMoneyIcon from '../../svg/Profilenavicons/PricecardIcon';
import { useProfileData } from '../../hooks/useProfileData';
import UserProfileSections from './UserProfileSections';
import TabSection from './TabSection';
// import MvAiReplies from './MvAiReplies';
import MyPosts from './MyPosts';
import MyReplies from './MyReplies';
import { AblyWebsocketChannelProvider } from '../../component/AblyWebsockets/AblyWebsocketChannelProvider';
import PremiumPurchaseButtonProfilePage from '../Purchases/premiumPurchaseButtonProfilePage';
import { useChannel } from 'ably/react';
import { PostType, CommentType } from '../memeverse/memeverse_types';
import CreateUpdateComment from '../memeverse/CreateUpdateComment';
import RefreshIcon from '@mui/icons-material/Refresh';
import { logging } from '../../utils/logger';
import MetaTags from '../../component/MetaTags';
import { useProductData } from '../../hooks/useProductData';
import { ProductDraft } from '../../context/ProductContext';
import ProductCard from '../Products/ProductCard';
import BroadcastModal from './BroadcastModal';
import SendIcon from '@mui/icons-material/Send';
import DynamicAdSense from '../memeverse/ads/DynamicAdSense';
import AvatarWithProgress from '../../component/AvatarWithProgress';
import OnboardingSection from './onBoardingSection';
import { usePremiumAccess } from '../../hooks/usePremiumAccess';

// Avatar with Progress Ring Component

interface ScoreBreakdown {
  profile: {
    total: number;
    verified: number;
    full_name: number;
    user_name: number;
    short_bio: number;
    profile_pic: number;
    completed_count: number;
    total_count: number;
  };
  personality: {
    total: number;
    birth_place: number;
    residence_place: number;
    occupation: number;
    gender: number;
    age: number;
    native_language: number;
    ethnicity: number;
    training_documents: number;
    completed_count: number;
    total_count: number;
  };
  social: {
    total: number;
    instagram: number;
    twitter: number;
    tiktok: number;
    youtube: number;
    linkedin: number;
    facebook: number;
    completed_count: number;
    total_count: number;
  };
  training: {
    total: number;
    documents: number;
    weblink: number;
    journaling: number;
    sitemap: number;
    google_drive: number;
    voice_sample: number;
    youtube_links: number;
    introduction: number;
    suggested_questions: number;
    edits_count: number;
    edits_score: number;
    journal_count: number;
    journal_score: number;
    completed_count: number;
    total_count: number;
  };
  ask: {
    total: number;
    posts_count: number;
    posts_score: number;
    comments_count: number;
    comments_score: number;
    completed_count: number;
    total_count: number;
  };
  monetization: {
    total: number;
    subscription_count: number;
    subscription_score: number;
    courses_count: number;
    courses_score: number;
    products_count: number;
    products_score: number;
    completed_count: number;
    total_count: number;
  };
  engagement: {
    total: number;
    follower_count: number;
    follower_score: number;
    fan_chat_count: number;
    fan_chat_score: number;
    referral_count: number;
    referral_score: number;
    persona_chat_count: number;
    persona_chat_score: number;
    completed_count: number;
    total_count: number;
  };
  praveena_points: number;
  overall_completed_count: number;
  overall_total_count: number;
}

interface DetailedProgressResponse {
  user_id: string;
  user_name: string;
  full_name: string;
  profile_pic_url: string;
  total_score: number;
  rank: number;
  score_breakdown: ScoreBreakdown;
  last_updated: string;
}

const UserProfilePage = ({ passedProduct }) => {
  return (
    <AblyWebsocketChannelProvider channelName='ask'>
      <UserProfileData passedProduct={passedProduct} />
    </AblyWebsocketChannelProvider>
  );
};

const UserProfileData = ({ passedProduct }) => {
  const { authUser } = useAuth();
  const { publish } = useChannel('ask');
  const { creatorProfileData: profileData } = useProfileData();
  const authDocumentId = authUser?.documentId;
  // const isProfileAuthUser = authUser?.documentId === profileData?.userId;

  const { premiumAccess } = usePremiumAccess(profileData);

  const message = useRef(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const [soopraSub, setSoopraSub] = useState<any>(null);
  const [activeTab, setActiveTab] = useState('onboarding');
  const [replyingTo, setReplyingTo] = useState<PostType | CommentType | null>(
    null
  );
  const [showRefreshButton, setShowRefreshButton] = useState<boolean>(false);
  const [broadcastModalOpen, setBroadcastModalOpen] = useState(false);

  const [profileProgress, setProfileProgress] = useState<number>(0);

  const [detailedData, setDetailedData] =
    useState<DetailedProgressResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const productIdToUse = useMemo(() => {
    return passedProduct || profileData?.subscription?.custom_product_id;
  }, [passedProduct, profileData?.subscription?.custom_product_id]);

  const { loadProducts, allProducts, incrementClickCount } = useProductData();

  const {
    userId = '',
    fullName = '',
    profilePicUrl = '',
    userName = '',
    occupation = '',
    index = '',
    // shortBio = '',
    subscription,
    // introMessage,
  } = profileData || {};

  const isProfileOwner = authDocumentId === userId;

  useEffect(() => {
    loadProducts(profileData?.userId, false).catch((error) => {
      console.log('This Creator has no products to be displayed', error);
    });
  }, [loadProducts, profileData]);

  useEffect(() => {
    if (isProfileOwner && userId) {
      setActiveTab('onboarding');
    } else if (userId) {
      setActiveTab('profile');
    }
  }, [isProfileOwner, userId]);

  useEffect(() => {
    async function fetchDetailedProgress() {
      try {
        setLoading(true);
        const response = await getOnBoradingDetailedProgress();
        if (response.ok) {
          const data = await response.json();
          setDetailedData(data);
          const completed = data.score_breakdown?.overall_completed_count ?? 0;
          const total = data.score_breakdown?.overall_total_count ?? 0;
          const progress = total > 0 ? (completed / total) * 100 : 0;
          setProfileProgress(parseFloat(progress.toFixed(1)));
        }
      } catch (error) {
        console.error('Error fetching detailed onboarding progress:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchDetailedProgress();
  }, []);

  async function fetchSubscriptions() {
    try {
      if (!productIdToUse) {
        console.warn('No product ID available for fetching subscriptions.');
        return;
      }

      getPrices([productIdToUse])
        .then((res) => {
          if (res.ok) {
            return res.json();
          }
          throw new Error(`HTTP error! status: ${res.status}`);
        })
        .then((data) => {
          let priceInfo = (data || {})[productIdToUse];
          if (priceInfo) {
            setSoopraSub(priceInfo);
          }
        })
        .catch((error) => {
          console.error('Error fetching subscription:', error);
        });
    } catch (error) {
      console.error('Error fetching subscription:', error);
    }
  }

  useEffect(() => {
    if (productIdToUse) {
      fetchSubscriptions();
    }
  }, [productIdToUse]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (replyingTo) {
      publish('comment.thinking.new', {
        userId: authUser?.uid,
        parentId: replyingTo.docId,
        level: 'comments_counts' in replyingTo ? 0 : 1,
        userType: 'user',
        user_details: {
          userName: authUser?.userName,
          profilePicUrl: authUser?.profilePicUrl,
          fullName: authUser?.fullName,
          user_id: authUser?.uid,
        },
      });
    }
    return () => {
      if (replyingTo) {
        publish('comment.thinking.remove', {
          userId: authUser?.uid,
          parentId: replyingTo.docId,
          level: 'level' in replyingTo ? replyingTo.level + 1 : 0,
          userType: 'user',
        });
      }
    };
  }, [replyingTo, authUser, publish]);

  useEffect(() => {
    if (!index) {
      const timer = setTimeout(() => {
        setShowRefreshButton(true);
      }, 30000); // Show refresh button after 30 seconds
      return () => clearTimeout(timer);
    }
  }, [index]);

  const handleSendMessage = (inputStr?: string) => {
    if (subscription?.custom_product_id && authUser && !premiumAccess) {
      if (inputStr || message.current?.value?.trim()) {
        // just navigate the user if they dont have premium access, dont send the message
        navigate(`/${userName}/chat`);
      }
    } else if (inputStr) {
      navigate(`/${userName}/chat`, { state: { message: inputStr } });
    } else if (message.current?.value?.trim()) {
      navigate(`/${userName}/chat`, {
        state: { message: message.current?.value },
      });
    }
  };

  const handleHardRefresh = () => {
    logging.info(
      'User has requested a hard refresh of the page on userProfileData'
    );
    window.location.reload();
  };

  const handleProductClick = (product: ProductDraft) => {
    if (profileData?.userId !== authUser?.uid) {
      incrementClickCount(profileData?.userId, product?.id);
      navigate(`/${profileData?.userName}/product/chat?p_id=${product.id}`);
    } else {
      navigate(`/${profileData?.userName}/product/chat?p_id=${product.id}`);
    }
  };
  return (
    <Box
      display='flex'
      flexDirection='column'
      flex='1'
      width='100%'
      height='100%'
    >
      <MetaTags
        title={`Meet ${profileData.fullName} – Chat, FAQs, Biography, and Courses | Soopra`}
        description={`Explore ${profileData.fullName}'s expertise, social links, and FAQs. Chat, learn, and engage with their AI persona on Soopra.`}
        image='https://soopra.ai/images/soopra_expert_profile_overview.png'
      />
      <Box
        sx={{
          py: { xs: 3, md: 4 },
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Outer container for Avatar and Name/Socials */}
        <Box
          display='flex'
          flexDirection={{ xs: 'column', md: 'row' }} // Column layout for mobile, row for larger screens
          alignItems={{ xs: 'center', md: 'flex-start' }}
          gap={{ xs: 1.5, md: 10 }} // Add spacing between avatar and text
        >
          {isProfileOwner ? (
            <AvatarWithProgress
              src={profilePicUrl}
              alt={fullName}
              fallback={fullName[0]}
              progress={profileProgress}
              loading={loading}
            />
          ) : (
            <Avatar
              src={profilePicUrl}
              alt={fullName}
              sx={{
                width: { xs: '124px', md: '211px' },
                height: { xs: '120px', md: '203px' },
                border: '2px solid #fff',
                borderRadius: '35%',
                objectFit: 'cover',
              }}
            >
              {fullName ? fullName[0] : ''}
            </Avatar>
          )}

          {/* Name/Socials and Buttons */}
          <Box
            display='flex'
            flexDirection='column'
            justifyContent='space-between'
            sx={{
              width: '100%',
              textAlign: { xs: 'center', md: 'left' }, // Center text on mobile, left-align on larger screens
              height: { xs: '100%', md: '203px' },
            }}
          >
            {/* TOP SECTION (Name, Socials) */}
            <Box
              sx={{
                mb: { xs: 1.5, MozTextDecorationStyle: 0 },
              }}
            >
              {/* Full Name + Verified */}
              <Box
                display='flex'
                alignItems='center'
                justifyContent={{ xs: 'center', md: 'flex-start' }}
              >
                <Typography variant='h6' fontWeight={600}>
                  {fullName}
                </Typography>
              </Box>

              {/* Username */}
              <Typography
                variant='body2'
                fontWeight={400}
                color='text.secondary'
              >
                @{userName}
              </Typography>

              {/* Occupation */}
              <Typography
                variant='body2'
                fontWeight={400}
                color='text.secondary'
              >
                {occupation}
              </Typography>

              {/* Subscription Details */}
              {soopraSub && (
                <Box
                  display='flex'
                  flexDirection='column'
                  sx={{
                    borderRadius: '4px',
                    my: 0.5,
                  }}
                >
                  <Typography
                    variant='body1'
                    sx={{
                      fontFamily: 'fontFamily',
                      fontWeight: 'fontWeightRegular',
                      fontSize: '0.875rem',
                      lineHeight: '20.02px',
                      letterSpacing: '0.17px',
                      color: 'text.secondary',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: { xs: 'center', md: 'flex-start' },
                    }}
                  >
                    <AttachMoneyIcon color={theme.palette.primary.main} />
                    <Box component='span' sx={{ pl: 1 }}>
                      {' '}
                      {/* Padding added here */}
                      {`Subscription - $${
                        Math.round(soopraSub.unit_amount || 0) / 100
                      }/${soopraSub.recurring?.interval || 'month'}`}
                    </Box>
                  </Typography>
                </Box>
              )}

              {/* Social Media Links  */}
              <SocialMediaLinks profileData={profileData} />
            </Box>

            {/* BOTTOM SECTION (Buttons) Mobile */}
            <Box
              sx={{
                display: { xs: 'flex', md: 'none' }, // Show this layout only on mobile
                flexDirection: 'column',
                gap: 1.5,
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  width: '100%',
                  gap: 1.5,
                }}
              >
                {/* Chat Button */}
                <Button
                  id='button-chat'
                  component='a'
                  href={`/${profileData.userName}/chat`}
                  variant='contained'
                  size='large'
                  color='primary'
                  disabled={!index}
                  startIcon={<ChatButtonIcon fill='none' />}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    navigate(`/${profileData.userName}/chat`);
                  }}
                  sx={{
                    width:
                      !!soopraSub && authDocumentId !== userId
                        ? 'auto'
                        : '100%',
                  }}
                >
                  Chat
                </Button>

                {!!soopraSub && authDocumentId !== userId && (
                  <PremiumPurchaseButtonProfilePage
                    requiredPremiumKey={
                      profileData?.subscription?.custom_product_id
                    }
                    redirectURL={`/${profileData.userName}/chat`}
                  />
                )}
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                  gap: 1.5,
                }}
              >
                {/* Journal Button */}
                {authDocumentId === userId && (
                  <Link to='update/journaling' style={{ flex: 1 }}>
                    <Button
                      id='button-journaling'
                      variant='outlined'
                      size='large'
                      color='secondary'
                      fullWidth
                      disabled={!index}
                      startIcon={
                        <JournalIcon
                          color={theme.palette.secondary.contrastText}
                        />
                      }
                      sx={{
                        flexGrow: 1,
                      }}
                    >
                      Journal
                    </Button>
                  </Link>
                )}

                {/* Edit Profile Button */}
                {authDocumentId === userId && (
                  <Link to={`/${userName}/update`} style={{ flex: 1 }}>
                    <Button
                      id={`button-edit-info-${userName}`}
                      variant='outlined'
                      color='secondary'
                      size='large'
                      fullWidth
                      sx={{
                        whiteSpace: 'nowrap',
                        flexGrow: 1,
                      }}
                      startIcon={
                        <EditOutlinedIcon
                          sx={{ color: theme.palette.secondary.contrastText }}
                        />
                      }
                    >
                      Edit Profile
                    </Button>
                  </Link>
                )}

                {/* Broadcast Button */}
                {authDocumentId === userId && (
                  <Button
                    id='button-broadcast'
                    variant='outlined'
                    color='secondary'
                    size='large'
                    fullWidth
                    disabled={!index}
                    onClick={() => setBroadcastModalOpen(true)}
                    startIcon={
                      <SendIcon
                        sx={{ color: theme.palette.secondary.contrastText }}
                      />
                    }
                    sx={{
                      flexGrow: 1,
                    }}
                  >
                    Broadcast
                  </Button>
                )}
              </Box>
            </Box>

            {/* Desktop and larger screens layout */}
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' }, // Show this layout only on larger screens
                flexDirection: 'row',
                gap: 1,
              }}
            >
              {/* Chat Button */}
              <Link to={`/${userName}/chat`} style={{ flex: 0 }}>
                <Button
                  id='button-chat'
                  variant='contained'
                  size='large'
                  color='primary'
                  disabled={!index}
                  startIcon={<ChatButtonIcon fill='none' />}
                >
                  Chat
                </Button>
              </Link>

              {/* Journal Button */}
              {authDocumentId === userId && (
                <Link to='update/journaling' style={{ flex: 0 }}>
                  <Button
                    id='button-journaling'
                    variant='outlined'
                    color='secondary'
                    size='large'
                    disabled={!index}
                    startIcon={
                      <JournalIcon
                        color={theme.palette.secondary.contrastText}
                      />
                    }
                  >
                    Journal
                  </Button>
                </Link>
              )}

              {/* Edit Profile Button */}
              {authDocumentId === userId && (
                <Link to={`/${userName}/update`} style={{ flex: 0 }}>
                  <Button
                    id={`button-edit-info-${userName}`}
                    variant='outlined'
                    color='secondary'
                    size='large'
                    startIcon={
                      <EditOutlinedIcon
                        sx={{ color: theme.palette.secondary.contrastText }}
                      />
                    }
                    sx={{
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Edit Profile
                  </Button>
                </Link>
              )}

              {/* Broadcast Button */}
              {authDocumentId === userId && (
                <Button
                  id='button-broadcast'
                  variant='outlined'
                  color='secondary'
                  size='large'
                  disabled={!index}
                  onClick={() => setBroadcastModalOpen(true)}
                  startIcon={
                    <SendIcon
                      sx={{ color: theme.palette.secondary.contrastText }}
                    />
                  }
                  sx={{
                    whiteSpace: 'nowrap',
                  }}
                >
                  Broadcast
                </Button>
              )}

              {!!soopraSub && authDocumentId !== userId && (
                <PremiumPurchaseButtonProfilePage
                  requiredPremiumKey={
                    profileData?.subscription?.custom_product_id
                  }
                  redirectURL={`/${profileData.userName}/chat`}
                />
              )}

              {/* Share Button */}
              <Box>
                <CopyToClipboardButton
                  copyLink={
                    !!profileData?.userName
                      ? `${window.location.origin}/${profileData?.userName}/chat`
                      : ''
                  }
                  buttonProps={{
                    disabled: !index,
                  }}
                  showSocialSharing={true}
                  profileName={profileData?.fullName || profileData?.userName}
                  profileBio={profileData?.shortBio}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 4,
            width: 1,
          }}
        >
          {allProducts && allProducts.length > 0 && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                width: 1,
              }}
            >
              <Typography variant='h7'>Products:</Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 2,
                  width: '100%',
                  overflowY: 'hidden',
                  overflowX: 'auto',
                  p: 1,
                }}
              >
                {allProducts.map((product: ProductDraft) => {
                  return (
                    <Box
                      key={`product-${product.id}`}
                      onClick={() => handleProductClick(product)}
                      sx={{
                        textDecoration: 'none',
                        cursor: 'pointer',
                        height: '15vh',
                      }}
                    >
                      <ProductCard product={product} layout='row' />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}
        </Box>
        {process.env.REACT_APP_ENABLE_ADS === 'true' && (
          <Box
            width='100%'
            maxWidth='lg'
            my={4}
            px={2}
            display='flex'
            justifyContent='center'
          >
            <DynamicAdSense adType='auto' />
          </Box>
        )}
        <TabSection
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isProfileOwner={isProfileOwner}
        />

        {activeTab === 'onboarding' && isProfileOwner && (
          <OnboardingSection
            progress={profileProgress}
            detailedData={detailedData}
            loading={loading}
          />
        )}

        {activeTab === 'profile' && <UserProfileSections />}

        <>
          {activeTab === 'posts' && (
            <MyPosts
              userId={userId}
              onReplyClick={(item) => setReplyingTo(item)}
            />
          )}

          {activeTab === 'replies' && (
            <MyReplies
              userId={userId}
              onReplyClick={(item) => setReplyingTo(item)}
            />
          )}

          {/* will make this work in future */}
          {/* {activeTab === 'aiReplies' && <MvAiReplies />} */}
        </>

        <Box width='100%' position='relative'>
          {/* Floating Textbox */}
          <Box
            sx={{
              position: 'fixed',
              bottom: {
                xs: '60px',
                md: '16px',
              },
              left: {
                xs: '50%',
                md: `calc((${drawerWidthClosed + drawerWidth}px)/2 + 50%)`,
              },
              transform: 'translateX(-50%)',
              width: {
                xs: '90%',
                md: `calc(100% - ${drawerWidthClosed + drawerWidth}px)`,
              },
              maxWidth: '800px',
              height: '44px',
              backgroundColor: theme.palette.background.paper,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '100px',
              padding: {
                xs: '8px 0px 8px 8px',
                md: '8px 0px 8px 8px',
              },
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
              display: 'flex',
              alignItems: 'center',
              zIndex: 10,
            }}
          >
            <Box
              sx={{
                marginLeft: '8px', // Space from the left edge
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Textboxstar />
            </Box>
            <TextField
              variant='outlined'
              placeholder='Ask anything...'
              fullWidth
              autoComplete='off'
              inputRef={message}
              defaultValue=''
              slotProps={{
                input: {
                  sx: {
                    borderRadius: '100px',
                    paddingRight: '12px',
                    '& fieldset': { border: 'none' },
                  },
                },
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleSendMessage();
                }
              }}
            />
            <IconButton
              color='primary'
              onClick={() => handleSendMessage()}
              sx={{
                ml: '12px', // Adjust spacing between the input and the button
              }}
            >
              <SendChatIcon isTextEntered={true} />
            </IconButton>
          </Box>
        </Box>
        <Box width='100%' mt={3}>
          {!index && (
            <Box
              display='flex'
              justifyContent='center'
              alignItems='center'
              textAlign='center'
              flexDirection='column'
              gap={2}
              my={3}
            >
              <Typography
                variant='body1'
                fontWeight={500}
                sx={{
                  justifyContent: 'center',
                  padding: 0.8,
                  borderRadius: 'none',
                  width: '100%',
                  maxWidth: '280px',
                }}
              >
                Your personality is being created! It may take a few minutes.
              </Typography>
              <CircularProgress
                size={30}
                sx={{
                  color: 'text.secondary',
                  display: showRefreshButton ? 'none' : 'block',
                }}
              />
              <Button
                variant='contained'
                color='primary'
                startIcon={<RefreshIcon />}
                onClick={handleHardRefresh}
                sx={{
                  display: showRefreshButton ? 'block' : 'none',
                }}
              >
                Waiting a while? Try Refreshing
              </Button>
            </Box>
          )}

          {/* Premium subscription button */}
          {/* {
              (subscription?.custom_product_id && !premiumAccess) ?
              <Suspense >
                <Box p={2.5}>
                  <PremiumPurchaseButton requiredPremiumKey={subscription.custom_product_id} redirectURL={`/${userName}/chat`}/>
                </Box>
              </Suspense> : <></>
            } */}
          <Box></Box>
        </Box>
      </Box>
      {replyingTo && (
        <Dialog
          open={!!replyingTo}
          onClose={() => setReplyingTo(null)}
          fullWidth
          maxWidth='md'
          slotProps={{
            backdrop: {
              sx: {
                display: { xs: 'none', md: 'block' },
              },
            },
          }}
          PaperProps={{
            sx: {
              m: 0,
              [theme.breakpoints.down('md')]: {
                width: '100%',
                maxWidth: '100%',
                height: 'calc(100% - 107px)',
                maxHeight: 'none',
                boxShadow: 'none',
                mt: '50px',
              },
            },
          }}
          sx={{
            [theme.breakpoints.down('md')]: {
              '& .MuiDialog-container': {
                alignItems: 'flex-start',
              },
            },
          }}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <CreateUpdateComment
            setCreateUpdateCommentVisible={() => setReplyingTo(null)}
            parentPostOrComment={replyingTo}
          />
        </Dialog>
      )}
      <BroadcastModal
        open={broadcastModalOpen}
        onClose={() => setBroadcastModalOpen(false)}
        creatorId={userId}
        creatorName={fullName}
      />
    </Box>
  );
};

export default UserProfilePage;
